import React from 'react';

const PrintsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/my-qs',
			exact: true,
			component: React.lazy(() => import('./PrintsPage')),
		},
		{
			path: '/admin/my-qs-direct',
			exact: true,
			component: React.lazy(() => import('./PrintsPage')),
		},
	],
};

export default PrintsPageConfig;
